export const CONTACT = {
  PHONE: "+36 30 613 3669",
  PHONELINK: "+36306133669",
  EMAIL: "info@koltozzolcson.hu",
  ADDRESS: "1118 Budapest, Villányi út 107. mf 2. ajtó",
  COMPANYNAME: "HD-Clean Trade Kft.",
  COMPANYREGISTRATIONNUMBER: "01-09-415885",
  COMPANYTAXNUMBER: "32281202-2-43",
};
